import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverable?: boolean;
}
export function Card({
  children,
  className = '',
  hoverable = false
}: CardProps) {
  return <div className={`bg-gray-800 border border-gray-700 rounded-lg shadow-md overflow-hidden ${hoverable ? 'transition-all duration-200 hover:shadow-lg hover:border-gray-600' : ''} ${className}`} data-id="element-771">
      {children}
    </div>;
}
interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}
export function CardHeader({
  children,
  className = ''
}: CardHeaderProps) {
  return <div className={`px-6 py-4 border-b border-gray-700 ${className}`} data-id="element-772">
      {children}
    </div>;
}
interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}
export function CardContent({
  children,
  className = ''
}: CardContentProps) {
  return <div className={`p-6 ${className}`} data-id="element-773">{children}</div>;
}
interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}
export function CardFooter({
  children,
  className = ''
}: CardFooterProps) {
  return <div className={`px-6 py-4 bg-gray-750 border-t border-gray-700 ${className}`} data-id="element-774">
      {children}
    </div>;
}